// src/hooks/useApi.js
import { useQuery, useMutation } from 'react-query';
import axiosInstance from '../lib/axios'; 
const token = localStorage.getItem('token');
// Function to fetch data
const fetchData = async (url) => {
  const response = await axiosInstance.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  // console.log(response.data)
  return response.data;
};

// Function for POST requests
const postData = async (url, data) => {
  const response = await axiosInstance.post(url, data);
  return response.data;
};

// Function for PUT requests
const putData = async (url, data) => {
  const response = await axiosInstance.put(url, data);
  return response.data;
};

// Function for DELETE requests
const deleteData = async (url) => {
  const response = await axiosInstance.delete(url);
  return response.data;
};

// Custom hook for GET requests
export const useGet = (url) => {
  return useQuery([url], () => fetchData(url),    {
    staleTime: 60000, // Cache data for 1 minute (60,000 ms)
    cacheTime: 300000, // Keep the data in the cache for 5 minutes (300,000 ms)
    refetchOnWindowFocus: false, // Prevent refetching when the window is focused
    refetchOnMount: false, // Prevent refetching on component mount if data is available
  });
};

// Custom hook for POST requests
export const usePost = (url) => {
  return useMutation((data) => postData(url, data));
};

// Custom hook for PUT requests
export const usePut = (url) => {
  return useMutation((data) => putData(url, data));
};

// Custom hook for DELETE requests
export const useDelete = (url) => {
  return useMutation(() => deleteData(url));
};
